import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UndoDeleteService } from '../../../../services/undo-delete.service';

/**
 * Snackbar de suppression avec undo.
 *
 * Centrée en bas de l'écran, empilée sous les toasts (styles/ui/floating-stack.scss).
 * Affiche une entrée par suppression en attente : libellé, minuteur visuel
 * (tasse qui se vide + liseré), bouton « Annuler » et bouton coche
 * « Supprimer maintenant » pour ne pas attendre le délai.
 *
 * À câbler une seule fois dans app.component.html (même niveau que
 * app-toast-container).
 */
@Component({
  selector: 'app-undo-snackbar',
  templateUrl: './undo-snackbar.component.html',
  styleUrl: './undo-snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UndoSnackbarComponent {
  protected readonly service = inject(UndoDeleteService);

  protected cancel(id: string): void {
    this.service.cancel(id);
  }

  protected confirmNow(id: string): void {
    this.service.confirmNow(id);
  }
}
